import { combineReducers } from '@reduxjs/toolkit';
import { dealsListReducer } from './dealsList/dealsList.slice';
import { creditPoolListReducer } from './creditPoolList/creditPoolList.slice';
import { currentDistributionReducer } from './currentDistribution/currentDistribution.slice';

export const creditsDistributionPoolsReducer = combineReducers({
  dealsList: dealsListReducer,
  creditPoolsList: creditPoolListReducer,
  current: currentDistributionReducer
});
